export default "__VITE_ASSET__BH7jDwQM__"